export function removeLocalItem(itemIdentifier) {
  localStorage.removeItem(itemIdentifier);
}

export function setLocalItem(itemIdentifier, data) {
  localStorage.setItem(itemIdentifier, data);
}
